const bearerTokenHeader = (accessToken: string) => ({
  Authorization: `Bearer ${accessToken}`,
})

export default bearerTokenHeader
